export default __webpack_public_path__ + "static/media/logo_t.0628b011.png";